// "1.1.0"のような単純なドット区切りバージョンだけを想定した比較(semverの複雑な仕様までは
// 対応しない、ブリッジのバージョン表記がこの形式で固定されているため十分)。
export function isVersionOlder(current: string, required: string): boolean {
    const toNums = (v: string) => v.split('.').map((s) => Number.parseInt(s, 10));
    const cur = toNums(current);
    const req = toNums(required);
    for (let i = 0; i < Math.max(cur.length, req.length); i++) {
        const c = cur[i] ?? 0;
        const r = req[i] ?? 0;
        // 解釈できない値は「古い(要更新)」側に倒す(数値以外を含む表記で誤って最新扱いにしない)
        if (Number.isNaN(c)) return true;
        if (Number.isNaN(r)) return false;
        if (c !== r) return c < r;
    }
    return false;
}
